import * as React from 'react';
import { useCallback } from 'react';
import { UIHeading3, UIText2 } from '@cian/ui-kit';
import classNames from 'classnames';
import { ServiceLayout } from '../ServiceLayout';
import * as styles from './GenericService.css';
import { EServiceId } from '../../../../../../../../../types/reducers/publishTerms';

interface IGenericService {
  title: string;
  subtitle: string;
  selected: boolean;
  disabled: boolean;
  blurred: boolean;
  children: React.ReactNode;
  serviceType: EServiceId;
  className: string;
  footer?: React.ReactNode;
  onSelect: (serviceType: EServiceId) => void;
}

export const GenericService = ({
  serviceType,
  title,
  subtitle,
  children,
  className,
  selected,
  blurred,
  disabled,
  footer,
  onSelect,
}: IGenericService) => {
  const handleClick = useCallback(() => {
    if (disabled || selected) {
      return;
    }
    onSelect(serviceType);
  }, [disabled, onSelect, selected, serviceType]);

  return (
    <div
      id={serviceType}
      onClick={handleClick}
      className={classNames(styles.root, { [styles.root_selected]: selected, [styles.root_disabled]: disabled })}
    >
      <ServiceLayout
        className={classNames(className, styles.item, {
          [styles.root_blurred]: blurred || disabled,
          [styles.item_selected]: selected,
        })}
        title={<UIHeading3>{title}</UIHeading3>}
        description={<UIText2>{subtitle}</UIText2>}
      >
        <div>{children}</div>
      </ServiceLayout>
      <div>{footer}</div>
    </div>
  );
};
